import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { generateRandomHexCode } from "../../../helpers/generateRandomHexCode";
import { getConfigDataByName } from "./getConfigDataByName";
import { inputTypes, tableData } from "../../../utils/tableData";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const GraphForStrings = ({ surveys }) => {
  const [reArrangedData, setReArrangedData] = useState([]);
  const [labels, setLabels] = useState([]);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: "compare chart"
      }
    }
  };

  //   const labels = Object.keys(surveys[0]);

  const data = {
    labels,

    datasets: [
      {
        label: "Survey",
        data: reArrangedData,
        backgroundColor: generateRandomHexCode()
      }
    ]
  };
  const reArrangeDataHandler = () => {
    let surveyCleaned = {};
    const keys = Object.keys(surveys[0]);
    keys.forEach((key) => {
      if (
        key == "id" ||
        key == "userId" ||
        key == "timestamp" ||
        key == "sessionId"
      ) {
        return;
      }
      let tableItem = getConfigDataByName(key);
      if (tableItem?.input?.type !== inputTypes.dropDown) return;

      surveys.forEach((surv) => {
        const value = surv[key];
        if (surveyCleaned[key]?.[value]) {
          surveyCleaned[key] = {
            ...surveyCleaned[key],
            [value]: surveyCleaned[key][value] + 1
          };
        } else {
          if (surveyCleaned[key]) {
            surveyCleaned[key] = { ...surveyCleaned[key], [value]: 1 };
          } else {
            surveyCleaned[key] = { [value]: 1 };
          }
        }
      });
    });
    console.log(surveyCleaned);
    let tempData = [];
    let tmpLabels = [];

    Object.keys(surveyCleaned).forEach((key) => {
      Object.keys(surveyCleaned[key]).forEach((key2, idx) => {
        tmpLabels.push(key2);
        tempData.push(surveyCleaned[key][key2]);
      });
    });
    // tableData.forEach((it) => {
    //   if (it.subs) {
    //     it.subs.forEach((it2) => {
    //       if (it2.input.type == inputTypes.dropDown) {
    //         Object.keys(surveyCleaned).forEach((key) => {
    //           Object.keys(surveyCleaned[key]).forEach((key2, idx) => {
    //             tmpLabels.push(key2);
    //             tempData.push(surveyCleaned[key][key2]);
    //           });
    //         });
    //       }
    //     });
    //   } else {
    //     if (it.input.type == inputTypes.dropDown) {
    //       Object.keys(surveyCleaned).forEach((key) => {
    //         Object.keys(surveyCleaned[key]).forEach((key2, idx) => {
    //           tmpLabels.push(key2);
    //           tempData.push(surveyCleaned[key][key2]);
    //         });
    //       });
    //     }
    //   }
    // });
    // const keys = Object.keys(surveys[0]);
    // let tempData = [];
    // const tmpLabels = [];
    // keys.forEach((key) => {
    //   if (
    //     key == "id" ||
    //     key == "userId" ||
    //     key == "timestamp" ||
    //     key == "sessionId"
    //   ) {
    //     return;
    //   }
    //   let tableItem = getConfigDataByName(key);
    //   let value ;

    //   if (tableItem?.input?.type == inputTypes.slider) return;
    //   tmpLabels.push(key);
    //   surveys.forEach((survey) => {
    //     value = (survey[key]);
    //   });
    //   tempData.forEach(it=>{
    //     if(it.label==value){

    //     }
    //   })
    //   tempData.push(value / surveys.length);
    // });

    console.log(tmpLabels, tempData, "tmpLabels");
    setReArrangedData(tempData);
    setLabels(tmpLabels);
  };
  useEffect(() => {
    reArrangeDataHandler();
  }, [surveys]);
  return (
    <div>
      <div className="w-[500px] h-[300px]">
        <Bar options={options} data={data} />
      </div>
    </div>
  );
};

export default GraphForStrings;
